/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  StaticHydratingSection
 */

import React, { useContext } from 'react'
import invariant from 'tiny-invariant'
import { ON_BROWSER, ON_SERVER } from '../../env'
import { StaticHTMLContext } from './StaticHTMLContext'

export interface StaticHydratingSectionProps<ForwardProps> {
  component: React.ComponentType<ForwardProps>
  forwardProps: ForwardProps
  initialLocationChanged: boolean
  name: string
}

const StaticHydratingSection = <ForwardProps extends object>({
  component: Component,
  forwardProps,
  initialLocationChanged,
  name,
}: StaticHydratingSectionProps<ForwardProps>) => {
  const staticRender = useContext(StaticHTMLContext)
  invariant(staticRender, '<StaticHydratingSection> used outside <StaticHTMLProvider>')

  const shouldRenderStaticHTML = ON_SERVER || (ON_BROWSER && !initialLocationChanged)

  if (shouldRenderStaticHTML) {
    const html = staticRender({ component: Component, forwardProps, name }) || ''
    return <div dangerouslySetInnerHTML={{ __html: html }} data-static-section={name} />
  }
  return <Component {...forwardProps} />
}

export default StaticHydratingSection
